import React from 'react'
import PropTypes from 'prop-types'
import {findDOMNode} from "react-dom"

import UI5CalendarContent from "./day-selection/calendar-content"
import UI5CalendarMonthSelection from "./month-selection/month-selection"
import UI5CalendarPresets from "./calendar-presets"
import Moment from "moment"

const debug = false
// const debug = "UI5CalendarRange"

export default class UI5CalendarRange extends React.Component {
    static propTypes = {
        selectedRange       : PropTypes.object,

        minDate             : PropTypes.object,                 // Moment, adds disabled option for view + no event on click
        maxDate             : PropTypes.object,

        daySize             : PropTypes.oneOf([30,36]),
        showTodayButton     : PropTypes.bool,                   // show button beside month title to jump to today on click
        singleDateSelection : PropTypes.bool,

        leftRenderComponent : PropTypes.any,
        rightRenderComponent: PropTypes.any,

        onSelect            : PropTypes.func,                   // on date selected -> returns moment
    }

    static defaultProps = {
        daySize         : 36,
        showTodayButton : true
    }

    constructor(props) {
        super(props)

        this.height = null // ??

        debug && console.log(debug, "constructor", props.selectedRange)

        let range
        if (props.selectedRange?.start && props.selectedRange?.end) {
            range = props.selectedRange
        } else if (props.selectedRange?.start) {
            range = Moment.range(props.selectedRange.start, Moment(props.selectedRange?.end).add(1, 'month'))
        } else if (props.selectedRange?.end) {
            range = Moment.range(Moment(props.selectedRange.end).subtract(1, 'month'), props.selectedRange.end)
        } else {
            if (props.singleDateSelection && props.leftRenderComponent) {
                range = Moment.range(Moment().subtract(1, 'month'), Moment())
            } else {
                range = Moment.range(Moment(), Moment().add(1, 'month'))
            }
        }

        const leftInitialMonth  = range.start
        const rightInitialMonth = range.start.isSame(range.end, 'month') ? range.end.clone().add(1, 'month') : range.end

        this.state = {
            mode                    : 'day-selection',
            leftInitialMonth        : leftInitialMonth,
            rightInitialMonth       : rightInitialMonth,

            selectedRange           : props.selectedRange,
            leftMaxNavigationDate   : rightInitialMonth.clone().subtract(1, 'month'),
            rightMinNavigationDate  : leftInitialMonth.clone().add(1, 'month'),
        }
    }

    onClickMonthSelection = (type, monthMoment) => {
        debug && console.log(debug, "onClickMonthSelection", type, monthMoment)

        this.height = findDOMNode(this).offsetHeight // to remain same height as in day-selection mode

        switch (type) {
            case 'left':
                this.setState({
                    mode                : 'month-selection-left',
                    leftInitialMonth    : monthMoment,
                })
                break

            case 'right':
                this.setState({
                    mode                : 'month-selection-right',
                    rightInitialMonth    : monthMoment,
                })
                break
        }
    }

    onBack = () => {
        this.height = null

        this.setState({
            mode: 'day-selection'
        })
    }

    onSelectMonth = (type, monthMoment) => {
        debug && console.log(debug, "onSelectMonth", type, monthMoment)

        switch (type) {
            case 'left' : this.onMonthChangedLeft(monthMoment, 'day-selection'); break
            case 'right': this.onMonthChangedRight(monthMoment, 'day-selection'); break
        }
    }

    onMonthChangedLeft = (monthMoment, mode) => {
        let newState = {
            leftInitialMonth        : monthMoment,
            rightMinNavigationDate  : monthMoment.clone().add(1, 'month')
        }

        debug && console.log(debug, "onMonthChangedLeft", mode, monthMoment.isSameOrAfter(this.state.leftMaxNavigationDate, 'month'), monthMoment, this.state.leftMaxNavigationDate)

        if (monthMoment.isSameOrAfter(this.state.leftMaxNavigationDate, 'month')) {
            newState = _.assign({}, newState, {
                rightInitialMonth      : newState.rightMinNavigationDate,
                leftMaxNavigationDate  : monthMoment
            })

            if (this.rightContent) this.rightContent.calendarHelper.setCurrentMonth(newState.rightMinNavigationDate)
        }

        if (mode) newState.mode = mode

        debug && console.log(debug, "onMonthChangedLeft newState", newState)

        this.setState(newState)
    }

    onMonthChangedRight = (monthMoment, mode) => {
        let newState = _.assign({}, newState, {
            rightInitialMonth       : monthMoment,
            leftMaxNavigationDate   : monthMoment.clone().subtract(1, 'month'),
        })

        debug && console.log(debug, "onMonthChangedRight", mode, monthMoment.isSameOrBefore(this.state.rightMinNavigationDate, 'month'), monthMoment, this.state.rightMinNavigationDate)

        if (monthMoment.isSameOrBefore(this.state.rightMinNavigationDate, 'month')) {
            newState = _.assign({}, newState, {
                leftInitialMonth        : newState.leftMaxNavigationDate,
                rightMinNavigationDate  : monthMoment
            })

            if (this.leftContent) this.leftContent.calendarHelper.setCurrentMonth(newState.leftMaxNavigationDate)
        }

        if (mode) newState.mode = mode

        debug && console.log(debug, "onMonthChangedRight newState", newState)

        this.setState(newState)
    }

    handleSelect = (selectedMoment) => {
        let range

        if (!this.state.firstSelected && !this.props.singleDateSelection){
            //first date selected
            range = Moment.range(selectedMoment, selectedMoment)

            const highlightRange = {
                startDate   : selectedMoment,
                endDate     : selectedMoment
            }

            if (this.leftContent)   this.leftContent.calendarHelper.setHighLightRange(highlightRange)
            if (this.rightContent)  this.rightContent.calendarHelper.setHighLightRange(highlightRange)

            this.setState({
                selectedRange   : range,
                firstSelected   : true,
                highlightRange
            })
        } else {
            //second date selected
            if (this.state.selectedRange?.start?.isAfter(selectedMoment)){
                range = Moment.range(selectedMoment, this.state.selectedRange.start)
            } else {
                range = Moment.range(this.state.selectedRange?.start ? this.state.selectedRange?.start : selectedMoment, selectedMoment)
            }

            this.setState({
                selectedRange   : range,
                firstSelected   : false,
                highlightRange  : null,
            }, ()=>{
                if(this.props.onSelect) this.props.onSelect(range)
            })
        }
    }

    handleHighlightDate = (highlightedMoment) => {
        if (this.state.firstSelected) {
            let highlightRange
            if (this.state.selectedRange.start.isAfter(highlightedMoment))
                highlightRange = {
                    startDate   : highlightedMoment,
                    endDate     : this.state.selectedRange.start
                }
            else
                highlightRange = {
                    startDate   : this.state.selectedRange.start,
                    endDate     : highlightedMoment
                }

            if (this.leftContent)   this.leftContent.calendarHelper.setHighLightRange(highlightRange)
            if (this.rightContent)  this.rightContent.calendarHelper.setHighLightRange(highlightRange)

            this.setState({
                highlightRange
            })
        }
    }

    renderLeft() {
        if (this.props.leftRenderComponent) {
            return <this.props.leftRenderComponent state={this.state} {...this.props}/>
        }

        const selectedDays = this.state.selectedRange ? [{
            startDate   : this.state.selectedRange.start,
            endDate     : this.state.selectedRange.end
        }] : null

        switch (this.state.mode) {
            case 'day-selection':
            case 'month-selection-right':
                return <UI5CalendarContent ref                      = {r => this.leftContent = r}
                                           className                = "left"
                                           initialMonth             = {this.state.leftInitialMonth}
                                           selectedDays             = {selectedDays}
                                           highlightRange           = {this.state.highlightRange}
                                           minDate                  = {this.props.minDate}
                                           maxDate                  = {this.props.maxDate}
                                           maxNavigationDate        = {this.state.leftMaxNavigationDate}
                                           showTodayButton          = {this.props.showTodayButton}
                                           sameHeightMonths         = {true}
                                           onClickMonthSelection    = {this.onClickMonthSelection.bind(this,'left')}
                                           onMonthChange            = {this.onMonthChangedLeft}
                                           onHighlightDate          = {this.handleHighlightDate}
                                           onSelect                 = {this.handleSelect}/>

            case 'month-selection-left':
                return <UI5CalendarMonthSelection className         = "left"
                                                  type              = "range"
                                                  initialMonth      = {this.state.leftInitialMonth}
                                                  selectedDays      = {selectedDays}
                                                  onSelectMonth     = {this.onSelectMonth.bind(this,'left')}
                                                  onBack            = {this.onBack}/>
        }
    }

    renderRight() {
        if (this.props.rightRenderComponent) {
            return <this.props.rightRenderComponent state={this.state} {...this.props}/>
        }

        const selectedDays = this.state.selectedRange ? [{
            startDate   : this.state.selectedRange.start,
            endDate     : this.state.selectedRange.end
        }] : null

        switch (this.state.mode) {
            case 'day-selection':
            case 'month-selection-left':
                return <UI5CalendarContent ref                      = {r => this.rightContent = r}
                                           className                = "right"
                                           initialMonth             = {this.state.rightInitialMonth}
                                           selectedDays             = {selectedDays}
                                           highlightRange           = {this.state.highlightRange}
                                           minDate                  = {this.props.minDate}
                                           maxDate                  = {this.props.maxDate}
                                           minNavigationDate        = {this.state.rightMinNavigationDate}
                                           showTodayButton          = {false}
                                           sameHeightMonths         = {true}
                                           focusOnLastDate          = {true}
                                           onClickMonthSelection    = {this.onClickMonthSelection.bind(this,'right')}
                                           onMonthChange            = {this.onMonthChangedRight}
                                           onHighlightDate          = {this.handleHighlightDate}
                                           onSelect                 = {this.handleSelect}/>

            case 'month-selection-right':
                return <UI5CalendarMonthSelection className         = "right"
                                                  type              = "range"
                                                  initialMonth      = {this.state.rightInitialMonth}
                                                  selectedDays      = {selectedDays}
                                                  onSelectMonth     = {this.onSelectMonth.bind(this,'right')}
                                                  onBack            = {this.onBack}/>
        }
    }

    render() {
        debug && console.log(debug, "render", this.state.selectedRange)

        const classes = Classes("ui5-calendar-2", "day-size-{0}".f(this.props.daySize))
        const style = this.height ? {height: this.height} : {}

        return (
            <div className={classes} style={style}>
                <UI5CalendarPresets presets={this.props.presets || []}/>
                <div className="range-content">
                    {this.renderLeft()}
                    {this.renderRight()}
                </div>
            </div>
        )

    }
}